import {ActionTree, GetterTree, Module, MutationTree} from "vuex";
import {RootState} from "@/store/types";
import {Purchase, PurchaseFilter, PurchaseState} from "@/modules/purchase/types";
import {getPurchase, getPurchases, savePurchases, getPurchaseByMaterialAndSupplierId} from "@/services/purchases";

export const state: PurchaseState = {
  purchase: {
    id: "",
    unit_price: "",
    date: "",
    id_item: "",
    id_supplier: ""
  }
}

const actions: ActionTree<PurchaseState, RootState> = {
  async GET_PURCHASE_BY_MATERIAL_AND_SUPPLIER_ID(_, payload: PurchaseFilter) {
    return await getPurchaseByMaterialAndSupplierId(payload);
  },
  async GET_PURCHASE(_, id) {
    return await getPurchase(id);
  },
  async GET_PURCHASES(_, payload: PurchaseFilter) {
    return await getPurchases(payload);
  },
  async SAVE_PURCHASES(_, purchases: Purchase[]) {
    return await savePurchases(purchases);
  }
}

const mutations: MutationTree<PurchaseState> = {
  SET_PURCHASE(state, purchase: Purchase) {
    state.purchase = purchase;
  }
}

const getters: GetterTree<PurchaseState, RootState> = {
  PURCHASE(state): Purchase {
    const {purchase} = state;
    return {...purchase};
  }
}

export const purchase: Module<PurchaseState, RootState> = {
  state,
  actions,
  getters,
  mutations
}
